import { render } from "./GameDetailsBox.vue?vue&type=template&id=71f1c5b8"
import script from "./GameDetailsBox.vue?vue&type=script&lang=js"
export * from "./GameDetailsBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__